import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";
import xlsx from "xlsx";
import $ from "jquery";
import moment from "moment";

import ControlRow from "../utils/components/ControlRow";
import ActionFleet from "./modals/ActionFleet";
import ActionEV from "./modals/ActionEV";
import ActionOtherEV from "./modals/ActionOtherEV";
import ActionCard from "./modals/ActionCard";
import ActionUser from "./modals/ActionUser";
import ContractEV from "./modals/ContractEV";
import SpecsEV from "./modals/SpecsEV";
import AssignDriver from "./modals/AssignDriver";
import ConfirmationModal from "../utils/components/ConfirmationModal";
import ChoiceModal from "../utils/components/ChoiceModal";
import { TOKEN_STATUS, prepareCSVDownload } from "../utils/Utils";
import download from "../../styles/images/download.svg";

import {
  searchModule,
  evioBase64,
  kintoBase64,
  handleCardStatus,
  calculateKm,
  calculateListDrivers,
  calculateMobileOfDrivers,
  getPlugInfo,
  checkNetwork,
  getIdentifier,
  formatBrand,
  translateEvType,
} from "../utils/Utils";
import { setAlert } from "../../actions/alertActions";
import toggle from "../utils/evio-toggle";
import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/evs/MyEVs.scss";
import car from "../../styles/images/vehicles/borderless/car.svg";
import plus from "../../styles/images/plus.svg";
import cog from "../../styles/images/cog.svg";
import pencil from "../../styles/images/pencil.svg";
import trashcan from "../../styles/images/trashcan.svg";
import no_vehicles from "../../styles/images/no_vehicles.svg";
import fleet_placeholder from "../../styles/images/fleet_placeholder.svg";
import evioSmallCard from "../../styles/images/evio_mini_card.svg";
import yes from "../../styles/images/yes.png";
import no from "../../styles/images/no.png";

//Enum card & network Status
const NETWORK_TOKEN = {
  STATUS_INACTIVE: "inactive",
  STATUS_TO_REQUEST: "toRequest",
  STATUS_ACTIVE: "active",
};

const CARD_PHYSICAL = {
  STATUS_INACTIVE: "inactive",
  STATUS_TO_REQUEST: "toRequest",
  STATUS_ACTIVE: "active",
};

const NETWORK_TYPE = {
  MOBIE: "MobiE",
  INTERNATIONAL_1: "server_international_network_1",
};

const TOKEN_TYPE = {
  APP_USER: "APP_USER",
  OTHER: "OTHER",
};

const CARD_TYPE = {
  VIRTUAL_PHYSICAL: "Virtual_Physical",
  VIRTUAL: "Virtual",
};

class MyEVs extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loadingActionCards: false,
      loading: true,
      isLoadingNetworkMobie: false,
      isLoadingNetworkGireve: false,
      search: "",
      fleets: [],
      selectedFleet: null,
      selectedEV: null,
      selectedEVCardNetworkStatus: {},
      masterContract: null,
      invoiceType: "INVOICE_INCLUDED",
      invoiceCommunication: "ONLY_COMPANY",
      acceptKMsFleet: false,
      updateKMsFleet: false,

      modals: {
        add: false,
        edit: false,
        delete: false,
        addEV: false,
        editEV: false,
        addOtherEV: false,
        editOtherEV: false,
        deleteEV: false,
        assign: false,
        contractEV: false,
        specsEV: false,
        addCard: false,
        editCard: false,
        addUser: false,
        editUser: false,
        choice: false,
        choiceEvs: false,
      },
    };

    this.fetchFleets = this.fetchFleets.bind(this);
    this.fetchCurrentFleet = this.fetchCurrentFleet.bind(this);
    this.handleAddFleet = this.handleAddFleet.bind(this);
    this.handleEditFleet = this.handleEditFleet.bind(this);
    this.handleDeleteFleet = this.handleDeleteFleet.bind(this);
    this.handleAddEV = this.handleAddEV.bind(this);
    this.handleAddOtherEV = this.handleAddOtherEV.bind(this);
    this.handleEditEV = this.handleEditEV.bind(this);
    this.handleAddCardUser = this.handleAddCardUser.bind(this);
    this.handleEditCardUser = this.handleEditCardUser.bind(this);
    this.handleEditOtherEV = this.handleEditOtherEV.bind(this);
    this.handleDeleteEV = this.handleDeleteEV.bind(this);
    this.handleAssignDriver = this.handleAssignDriver.bind(this);
    this.deactivateNetwork = this.deactivateNetwork.bind(this);
    this.activateNetwork = this.activateNetwork.bind(this);
    this.onJoin = this.onJoin.bind(this);
    this.joinNetwork = this.joinNetwork.bind(this);
    this.handleInvoiceTypeChange = this.handleInvoiceTypeChange.bind(this);
    this.handleInvoiceCommunicationChange =
      this.handleInvoiceCommunicationChange.bind(this);
    this.toggleLoadingActionCards = this.toggleLoadingActionCards.bind(this);
    this.handleToggleAcceptKms.bind(this);
    this.handleToggleEditKms.bind(this);
    this.updaterfidUIState = this.updaterfidUIState.bind(this);
  }

  updaterfidUIState(newRfidUIState) {
    this.safeSetState((prevState) => {
      if (!prevState.selectedEV || !prevState.selectedFleet) return {};

      const updatedSelectedEV = {
        ...prevState.selectedEV,
        contract: {
          ...prevState.selectedEV.contract,
          rfidUIState: newRfidUIState,
        },
      };

      const updatedListEvs = prevState.selectedFleet.listEvs.map((ev) =>
        ev.evId === prevState.selectedEV.evId
          ? { ...ev, contract: { ...ev.contract, rfidUIState: newRfidUIState } }
          : ev
      );

      const updatedFleets = prevState.fleets.map((fleet) =>
        fleet._id === prevState.selectedFleet._id
          ? { ...fleet, listEvs: updatedListEvs }
          : fleet
      );

      return {
        selectedEV: updatedSelectedEV,
        selectedFleet: {
          ...prevState.selectedFleet,
          listEvs: updatedListEvs,
        },
        fleets: updatedFleets,
      };
    });
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchFleets();
  }

  updateSelectedEV = (updatedEV) => {
    this.safeSetState((prevState) => {
      if (!prevState.selectedEV || !prevState.selectedFleet) return {};

      // Update selectedEV
      const newSelectedEV = {
        ...prevState.selectedEV,
        ...updatedEV,
        contract: {
          ...prevState.selectedEV.contract,
          ...updatedEV.contract,
        },
      };

      // Update listEvs in selectedFleet
      const updatedListEvs = prevState.selectedFleet.listEvs.map((ev) =>
        ev.evId === newSelectedEV.evId
          ? { ...ev, ...newSelectedEV, contract: { ...ev.contract, ...newSelectedEV.contract } }
          : ev
      );

      // Update fleets
      const updatedFleets = prevState.fleets.map((fleet) =>
        fleet._id === prevState.selectedFleet._id
          ? { ...fleet, listEvs: updatedListEvs }
          : fleet
      );

      return {
        selectedEV: newSelectedEV,
        selectedFleet: {
          ...prevState.selectedFleet,
          listEvs: updatedListEvs,
        },
        fleets: updatedFleets,
      };
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.selectedEV !== this.state.selectedEV &&
      this.state.selectedEV !== null
    ) {
      this.state?.selectedEV?.contract &&
        this.setSelectedEVCardNetworkStatus(this.state.selectedEV.contract);
    }
  }

  toggleLoadingActionCards = (isLoading) => {
    this.setState((prevState) => ({
      loadingActionCards: isLoading,
    }));
  };

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  onJoin() {
    this.setModal("contractEV", false);
  }

  handleInvoiceTypeChange(e) {
    this.safeSetState({
      invoiceType: e.target.value,
    });
  }

  handleInvoiceCommunicationChange(e) {
    this.safeSetState({
      invoiceCommunication: e.target.value,
    });
  }

  getNumberOfDrivers(ev) {
    if (ev) {
      const { listOfDrivers, listOfGroupDrivers } = ev;
      const evDrivers = listOfDrivers && [
        ...listOfDrivers.filter((d) => d.userId && d.userId !== ""),
      ];

      if (listOfGroupDrivers && listOfGroupDrivers.length > 0) {
        listOfGroupDrivers.forEach((group) => {
          if (group.listOfDrivers && group.listOfDrivers.length > 0) {
            group.listOfDrivers.forEach((driver) => {
              if (!driver.admin && driver.driverId && driver.driverId !== "") {
                const idx = evDrivers.findIndex(
                  (d) =>
                    d.userId === driver.driverId ||
                    d.driverId === driver.driverId
                );
                if (idx === -1) evDrivers.push(driver);
              }
            });
          }
        });

        return evDrivers && evDrivers.length;
      } else if (evDrivers) {
        return evDrivers && evDrivers.length;
      } else {
        return "-";
      }
    } else {
      return "-";
    }
  }

  fetchFleets() {
    axios
      .get("/api/private/fleets", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              loading: false,
              fleets: res.data,
            },
            () => {
              if (this.state.fleets.length > 0) {
                let idx = -1;
                if (this.state.selectedFleet)
                  idx = this.state.fleets.findIndex(
                    (f) => f._id === this.state.selectedFleet._id
                  );
                this.safeSetState(
                  {
                    selectedFleet:
                      idx !== -1
                        ? this.state.fleets[idx]
                        : this.state.fleets[0],
                  },
                  () => {
                    if (this.state.selectedFleet && this.state.selectedEV) {
                      const newSelectedEV =
                        this.state.selectedFleet.listEvs.find(
                          (f) => f.evId === this.state.selectedEV.evId
                        );

                      this.safeSetState({
                        selectedEV: newSelectedEV ? newSelectedEV : null,
                      });
                    }
                  }
                );
              }
            }
          );
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      });
  }

  fetchCurrentFleet(id) {
    axios
      .get("/api/private/fleets/byId", {
        params: { _id: id },
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              loading: false,
              selectedFleet: res.data,
            },
            () => {
              if (this.state.selectedFleet && this.state.selectedEV) {
                const newSelectedEV = this.state.selectedFleet.listEvs.find(
                  (f) => f.evId === this.state.selectedEV.evId
                );

                this.safeSetState({
                  selectedEV: newSelectedEV ? newSelectedEV : null,
                });
              }
            }
          );
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      });
  }

  handleAddFleet(
    assetDatas,
    imageContent,
    sharedWithOPC = false,
    shareEVData = false
  ) {
    const name = assetDatas.fleetName.value;

    const post = {
      name,
      imageContent: imageContent
        ? imageContent
        : this.props.brand?.brandName === "KINTO"
        ? kintoBase64
        : evioBase64,
      listEvs: [],
      sharedWithOPC,
      shareEVData,
    };

    axios
      .post("/api/private/fleets", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_addSuccess"), "primary");
          this.fetchFleets();
          this.setModal("add", false);
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleEditFleet(
    assetDatas,
    _id,
    imageContent,
    sharedWithOPC = false,
    shareEVData = false,
    acceptKMs = false,
    updateKMs = false,
    acceptKMsFleet = false,
    updateKMsFleet = false
  ) {
    const name = assetDatas.fleetName.value;

    const patch = {
      _id,
      name,
      imageContent: imageContent
        ? imageContent
        : this.props.brand?.brandName === "KINTO"
        ? kintoBase64
        : evioBase64,
      sharedWithOPC,
      shareEVData: sharedWithOPC ? shareEVData : false,
    };

    axios
      .patch("/api/private/fleets", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_genericEditSuccess"), "primary");
          this.fetchFleets();
          this.setModal("edit", false);
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });

    const acceptKMsPatch = {
      fleetID: _id,
      acceptKMs: acceptKMsFleet,
    };

    axios
      .patch("/api/private/fleets/acceptKMs", acceptKMsPatch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_editSuccess"), "primary");
          this.fetchFleets();
          this.setModal("edit", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );

    const updateKMsPatch = {
      fleetID: _id,
      updateKMs: acceptKMsFleet ? updateKMsFleet : false,
    };
    axios
      .patch("/api/private/fleets/updateKMs", updateKMsPatch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_editSuccess"), "primary");
          this.fetchFleets();
          this.setModal("edit", false);
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      });
  }

  handleDeleteFleet() {
    axios
      .delete("/api/private/fleets", {
        data: { _id: this.state.selectedFleet._id },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_deleteSuccess"), "primary");
          this.fetchFleets();
          this.setModal("delete", false);
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      });
  }

  handleAddEV(ev, licensePlate, country, otherInfo) {
    const post = Object.assign({}, ev, {
      fleet: this.state.selectedFleet._id,
      version: ev.version === null ? "" : ev.version,
      licensePlate,
      country,
      otherInfo,
    });
    axios
      .post("/api/private/evs", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_addEVSuccess"), "primary");
          this.fetchCurrentFleet(this.state.selectedFleet._id);
          this.setModal("addEV", false);
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleAddOtherEV(
    imageContent,
    evType,
    licensePlate,
    brand,
    model,
    batteryCapacity,
    country,
    plugs,
    otherInfo
  ) {
    const post = {
      fleet: this.state.selectedFleet._id,
      brand,
      model,
      batteryCapacity,
      evType,
      imageContent,
      licensePlate,
      country,
      plugs: plugs.map((p) => ({ plugType: p.name, plugPower: p.power })),
      otherInfo,
    };

    axios
      .post("/api/private/otherEvs", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_genericAddSuccess"), "primary");
          this.fetchCurrentFleet(this.state.selectedFleet._id);
          this.setModal("addOtherEV", false);
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
        this.toggleLoadingActionCards(false);
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleEditEV(evInfo, ev, licensePlate, country, otherInfo, vehicleId) {
    const { brand, model, version, dateFrom, dateTo, imageContent } = evInfo;
    delete evInfo.imageContent;
    const patch = Object.assign({}, ev, {
      _id: ev.evId,
      brand,
      model,
      version: version === null ? "" : version,
      evInfo: Object.assign({}, ev.evInfo, { databaseVehicleId: 0 }),
      dateFrom,
      dateTo: dateTo === null ? "" : dateTo,
      country,
      imageContent: imageContent
        ? imageContent
        : this.props.brand?.brandName === "KINTO"
        ? kintoBase64
        : evioBase64,
      licensePlate,
      otherInfo,
      vehicleId,
    });
    axios
      .patch("/api/private/evs", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_editEVSuccess"), "primary");
          this.fetchCurrentFleet(this.state.selectedFleet._id);
          this.setModal("editEV", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      )
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleToggleAcceptKms(id, acceptKMs) {
    const patch = {
      evID: id,
      acceptKMs: acceptKMs,
    };

    axios
      .patch("/api/private/evs/acceptKMs", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          if (acceptKMs === false) {
            this.handleToggleEditKms(id, false);
          }

          this.fetchFleets();
          this.props.setAlert(I18n.t("evs_editEVSuccess"), "primary");
          this.setModal("editEV", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleToggleEditKms(id, updateKMs) {
    const patch = {
      evID: id,
      updateKMs: updateKMs,
    };

    axios
      .patch("/api/private/evs/updateKMs", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_editEVSuccess"), "primary");
          this.fetchFleets();
          this.setModal("editEV", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleEditOtherEV(
    ev,
    imageContent,
    evType,
    licensePlate,
    brand,
    model,
    batteryCapacity,
    country,
    plugs,
    otherInfo
  ) {
    const patch = {
      _id: ev.evId,
      fleet: this.state.selectedFleet._id,
      brand,
      model,
      evType,
      imageContent,
      licensePlate,
      country,
      evInfo: Object.assign({}, ev.evInfo, {
        maxBatteryCapacity: batteryCapacity,
        useableBatteryCapacity: batteryCapacity,
        plugs: plugs.map((p) => ({ plugType: p.name, plugPower: p.power })),
      }),
      otherInfo,
    };
    axios
      .patch("/api/private/otherEvs", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_genericEditSuccess"), "primary");
          this.fetchCurrentFleet(this.state.selectedFleet._id);
          this.setModal("editOtherEV", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      )
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleAddCardUser(
    imageContent,
    licensePlate,
    brand,
    model,
    country,
    otherInfo
  ) {
    const post = {
      fleet: this.state.selectedFleet._id,
      evType: "otherEv",
      brand: brand,
      model,
      imageContent,
      licensePlate,
      country,
      otherInfo,
    };
    axios
      .post("/api/private/otherEvs", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_genericAddSuccess"), "primary");
          this.fetchFleets();
          if (brand === "TYPECARD") {
            this.setModal("addCard", false);
          } else {
            this.setModal("addUser", false);
          }
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      )
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleEditCardUser(
    ev,
    imageContent,
    licensePlate,
    brand,
    model,
    country,
    otherInfo
  ) {
    const patch = {
      _id: ev.evId,
      fleet: this.state.selectedFleet._id,
      evType: "otherEv",
      brand,
      model,
      imageContent,
      licensePlate,
      country,
      evInfo: ev.evInfo,
      otherInfo,
    };

    axios
      .patch("/api/private/otherEvs", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("evs_genericEditSuccess"), "primary");
          this.fetchCurrentFleet(this.state.selectedFleet._id);
          if (brand === "TYPECARD") {
            this.setModal("editCard", false);
          } else {
            this.setModal("editUser", false);
          }
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      )
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleDeleteEV() {
    this.toggleLoadingActionCards(true);
    axios
      .delete("/api/private/evs", {
        data: { _id: this.state.selectedEV.evId },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              selectedEV: null,
            },
            () => {
              this.props.setAlert(I18n.t("evs_deleteEVSuccess"), "primary");
              this.fetchCurrentFleet(this.state.selectedFleet._id);
              this.setModal("deleteEV", false);
            }
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      )
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  handleAssignDriver(groups, drivers) {
    const patch = {
      evId: this.state.selectedEV.evId,
      listOfGroupDrivers: groups.map((g) => ({
        groupId: g._id,
        paymenteBy: "myself",
        billingBy: "owner",
        period: g.period,
      })),
      listOfDrivers: drivers.map((d) => ({
        _id: d._id,
        userId: d.driverId || "",
        name: d.name,
        paymenteBy: drivers.length > 1 ? "myself" : d.paymenteBy,
        billingBy: drivers.length > 1 ? "owner" : d.billingBy,
        period: d.period,
        internationalPrefix: d.internationalPrefix,
        mobile: d.mobile,
      })),
      invoiceType:
        groups?.length > 0
          ? "INVOICE_INCLUDED"
          : drivers?.length === 1 &&
            drivers[0]?.billingBy === "driver" &&
            drivers[0]?.paymenteBy === "driver"
          ? "NOT_APPLICABLE"
          : (drivers[0]?.billingBy === "driver" &&
              drivers[0]?.paymenteBy === "myself") ||
            drivers?.length > 1
          ? "INVOICE_INCLUDED"
          : this.state.invoiceType,
      invoiceCommunication:
        groups?.length > 0
          ? "ONLY_COMPANY"
          : drivers[0]?.billingBy === "driver" &&
            drivers[0]?.paymenteBy === "driver"
          ? "NOT_APPLICABLE"
          : this.state.invoiceType === "INVOICE_INCLUDED" ||
            drivers[0].billingBy === "driver" ||
            drivers.length > 1
          ? "ONLY_COMPANY"
          : this.state.invoiceCommunication,
    };

    axios
      .patch("/api/private/evs/assigningDrivers", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t(res.data.message), "primary");
          this.fetchFleets();
          this.setModal("assign", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  createFleet(post) {
    axios
      .post("/api/private/fleets", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {})
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  setModal(modal, bool, callback) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState(
      {
        modals: newModals,
      },
      callback
    );
  }

  setSelectedEVCardNetworkStatus(contract, callback) {
    const selectedEVCardNetworkStatus = handleCardStatus(contract);
    this.safeSetState({ selectedEVCardNetworkStatus }, callback);
  }

  joinNetwork(network, contractId) {
    const post = {
      network: network,
      contractId: contractId,
    };

    if (network === "MobiE") {
      this.safeSetState({
        isLoadingNetworkMobie: true,
      });
    } else if (network === "Gireve") {
      this.safeSetState({
        isLoadingNetworkGireve: true,
      });
    }

    axios
      .post("/api/private/contracts/activeNetworks", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t(res.data.message.code), "primary");
          this.fetchFleets();
          if (network === "MobiE") {
            this.safeSetState({
              isLoadingNetworkMobie: false,
            });
          } else if (network === "Gireve") {
            this.safeSetState({
              isLoadingNetworkGireve: false,
            });
          }
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  updateSelectedFleetAndSelectedEV(network, status) {
    const newSelectedEV = {
      ...this.state.selectedEV,
      contract: {
        ...this.state.selectedEV.contract,
        networks: this.state.selectedEV?.contract?.networks.map((net) => {
          if (net.network !== network) {
            return net;
          }
          return {
            ...net,
            tokens: net.tokens.map((token) => ({ ...token, status })),
          };
        }),
      },
    };

    const newSelectedFleet = {
      ...this.state.selectedFleet,
      listEvs: this.state.selectedFleet.listEvs.map((ev) => {
        if (ev._id !== this.state.selectedEV?._id) {
          return ev;
        }
        return newSelectedEV;
      }),
    };

    const newFleets = this.state.fleets.map((fleet) =>
      fleet._id === newSelectedFleet._id ? newSelectedFleet : fleet
    );

    this.safeSetState({
      selectedEV: newSelectedEV,
      selectedFleet: newSelectedFleet,
      fleets: newFleets,
    });
  }

  activateNetwork(network, contractId) {
    const patch = {
      network: network,
      contractId: contractId,
    };

    this.updateSelectedFleetAndSelectedEV(network, TOKEN_STATUS.ACTIVATING);

    axios
      .patch("/api/private/contracts/activeNetwork", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        if (response.status === 200) {
          this.updateSelectedFleetAndSelectedEV(network, TOKEN_STATUS.ACTIVE);
          this.props.setAlert(I18n.t("network_ActivationSuccess"), "primary");
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
      })
      .finally(() => {
        this.toggleLoadingActionCards(false);
      });
  }

  deactivateNetwork(network, contractId) {
    const patch = {
      network: network,
      contractId: contractId,
    };

    this.updateSelectedFleetAndSelectedEV(network, TOKEN_STATUS.INACTIVATING);

    axios
      .patch("/api/private/contracts/inactiveNetwork", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((response) => {
        if (response.status === 200) {
          this.updateSelectedFleetAndSelectedEV(network, TOKEN_STATUS.INACTIVE);
          this.props.setAlert(I18n.t("network_DeactivationSuccess"), "primary");
        }
      })
      .catch((err) => {
        const errorCode =
          err?.response?.data?.code || "general_genericErrorMessage";
        this.props.setAlert(I18n.t(errorCode), "danger");
        this.fetchFleets();
      });
  }

  prepareKmsExportByEv() {
    const newEvKms = this.state.fleets.reduce((obj, item) => {
      item.listEvs.forEach((ev) => {
        if (!(ev.licensePlate in obj)) {
          obj[ev.licensePlate] = {
            ev: ev.licensePlate,
            fleet: item.name,
            brand: ev.brand,
            model: ev.model,
          };
        }

        const listOfKMs = ev.listOfKMs ? ev.listOfKMs : [];

        listOfKMs.forEach((km) => {
          const date = moment(km.kmsDate).format("YYYY-MM-DD");

          if (!(date in obj[ev.licensePlate])) {
            obj[ev.licensePlate][date] = 0;
          }

          obj[ev.licensePlate][date] += km.kms;
        });
      });
      return obj;
    }, {});

    return Object.values(newEvKms);
  }

  handleOnChoose(idx) {
    this.setModal("choice", false);
    const dataEv = this.prepareKmsExportByEv();
    const filteredDataEv = dataEv.filter((row) => Object.keys(row).length > 4);
    const allDates = Array.from(
      filteredDataEv.reduce((dates, row) => {
        Object.keys(row)
          .filter((key) => !["ev", "fleet", "model", "brand"].includes(key))
          .forEach((date) => dates.add(date));

        return dates;
      }, new Set())
    );

    let ws = xlsx.utils.json_to_sheet(filteredDataEv, {
      header: ["ev", "fleet", "model", "brand", ...allDates.sort()],
    });

    if (idx === 0) {
      let ws_to_csv = xlsx.utils.sheet_to_csv(ws);
      const newDataEV = ws_to_csv.split("\n").map((s) => s.split(","));

      const download = prepareCSVDownload(newDataEV, "Kms.csv");

      $("#downloadFile").append(download);
      download.click();
      $("#downloadFile").remove(download);
    } else if (idx === 1) {
      let wb = xlsx.utils.book_new();

      const sheetName = "Km evs";
      wb.SheetNames.push(sheetName);

      wb.Sheets[sheetName] = ws;

      xlsx.writeFile(
        wb,
        `${
          this.props.brand.brandTitle + I18n("history_titleTab") + sheetName
        }.xlsx`
      );
    }
  }

  handleOnChooseEvs(idx) {
    const fleetName = this.state.selectedFleet.name;

    this.setModal("choice", false);

    const dataEv = this.prepareExportEvs();

    let ws = xlsx.utils.json_to_sheet(dataEv, {
      header: [
        I18n.t("associatedCard"),
        I18n.t("numberKm"),
        I18n.t("licensePlate"),
        I18n.t("mobileAssociatedEmployees"),
        I18n.t("associatedEmployees"),
        I18n.t("exportAssets_identifier"),
        I18n.t("exportAssets_plugInfo"),
        I18n.t("exportAssets_assetType"),
        I18n.t("exportAssets_evType"),
        I18n.t("exportAssets_maxBatteryCapacity"),
        I18n.t("exportAssets_useableBatteryCapacity"),
        I18n.t("exportAssets_cardName"),
        I18n.t("exportAssets_cardNumber"),
        "EVIO",
        "MOBIE",
        "Roaming",
      ],
    });

    if (idx === 0) {
      let ws_to_csv = xlsx.utils.sheet_to_csv(ws);
      const newDataEV = ws_to_csv.split("\n").map((s) => s.split(","));

      const download = prepareCSVDownload(
        newDataEV,
        "evs_" + fleetName + ".csv"
      );

      $("#downloadFile").append(download);
      download.click();
      $("#downloadFile").remove(download);
    } else if (idx === 1) {
      let wb = xlsx.utils.book_new();

      const sheetName = "evs_" + fleetName;
      wb.SheetNames.push(sheetName);

      wb.Sheets[sheetName] = ws;

      xlsx.writeFile(wb, `${sheetName}.xlsx`);
    }
  }

  prepareExportEvs() {
    const selectedFleet = this.state.selectedFleet;
    const listEVs = selectedFleet.listEvs;
    let ListOfEvsFiltered = [];

    if (listEVs.length > 0) {
      listEVs.forEach((assetData) => {
        // avoids corrupted objects that might not have the standardized format
        const brand = assetData.brand;
        if (brand !== null && assetData.contract) {
          const licensePlate = I18n.t("licensePlate");
          const associatedCard = I18n.t("associatedCard");
          const numberKm = I18n.t("numberKm");
          const mobileAssociatedEmployees = I18n.t("mobileAssociatedEmployees");
          const associatedEmployees = I18n.t("associatedEmployees");
          const identifier = I18n.t("exportAssets_identifier");
          const plugInfo = I18n.t("exportAssets_plugInfo");
          const assetType = I18n.t("exportAssets_assetType");
          const evType = I18n.t("exportAssets_evType");
          const maxBatteryCapacity = I18n.t("exportAssets_maxBatteryCapacity");
          const useableBatteryCapacity = I18n.t(
            "exportAssets_useableBatteryCapacity"
          );
          const cardName = I18n.t("exportAssets_cardName");
          const cardNumber = I18n.t("exportAssets_cardNumber");

          console.log(assetData.contract)
          const ev = {
            [identifier]: getIdentifier(assetData),
            [plugInfo]: getPlugInfo(assetData),
            [assetType]: formatBrand(assetData.brand),
            [evType]: translateEvType(assetData.evType),
            [maxBatteryCapacity]: assetData?.evInfo?.maxBatteryCapacity,
            [useableBatteryCapacity]: assetData?.evInfo?.useableBatteryCapacity,
            [cardName]: assetData?.contract?.cardName,
            [cardNumber]: assetData?.contract?.cardNumber,
            EVIO: checkNetwork(
              assetData?.contract?.networks,
              "EVIO"
            ).toString(),
            MOBIE: checkNetwork(
              assetData?.contract?.networks,
              "MobiE"
            ).toString(),
            Roaming: checkNetwork(
              assetData?.contract?.networks,
              "server_international_network_1"
            ).toString(),
            [licensePlate]: assetData.licensePlate
              ? assetData.licensePlate
              : "",
            [associatedCard]: assetData.contract
              ? assetData.contract.cardPhysicalState
                ? I18n.t("general_yes")
                : I18n.t("general_no")
              : "",
            [numberKm]: calculateKm(assetData.listOfKMs),
            [associatedEmployees]: calculateListDrivers(
              assetData.listOfDrivers
            ).toString(),
            [mobileAssociatedEmployees]: calculateMobileOfDrivers(
              assetData.listOfDrivers
            ).toString(),
          };
          ListOfEvsFiltered.push(ev);
        }
      });
    }
    return ListOfEvsFiltered;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const { modals, selectedEV } = this.state;
    const isAddMode = modals.addEV;
    const isEditMode = modals.editEV;

    // Determine the mode and related props
    let actionMode, onHide, onSubmit, additionalProps;
    if (isAddMode) {
      actionMode = "add";
      onHide = () => this.setModal("addEV", false);
      onSubmit = this.handleAddEV;
      additionalProps = {}; // No additional props for add mode
    } else if (isEditMode) {
      actionMode = "edit";
      onHide = () =>
        this.safeSetState({ selectedEV: null }, () =>
          this.setModal("editEV", false)
        );
      onSubmit = this.handleEditEV;
      additionalProps = { selectedEV }; // Add additional props for edit mode
    }

    return !this.state.loading ? (
      <>
        <div id="myEVs" className="main-container">
          <div className="control-bar">
            <ControlRow
              showSearch={this.state.fleets.length > 0}
              search={this.state.search}
              onSearchChange={(e) =>
                searchModule.setSearch(this, e.target.value)
              }
              showCarousel={this.state.fleets.length > 0}
              carousel={{
                items: this.state.fleets || [],
                selected: this.state.selectedFleet
                  ? this.state.fleets.findIndex(
                      (i) => i._id === this.state.selectedFleet._id
                    )
                  : 0,
                placeholder: fleet_placeholder,
                onSelect: (selectedFleet) =>
                  this.safeSetState({ selectedFleet }),
              }}
              buttons={[
                {
                  label: "evs_addNewFleet",
                  text: plus,
                  onClick: (e) => {
                    e.stopPropagation();
                    this.setModal("add", true);
                  },
                  disabled:
                    this.state.loading ||
                    (this.props.isAdmin === false &&
                      this.state.fleets.length >=
                        this.props.userPackage?.fleetsLimit),
                },
                {
                  show: this.state.selectedFleet !== null,
                  className: "clear",
                  text: <img src={cog} alt={I18n.t("evs_editFleet")} />,
                  onClick: (e) => {
                    e.stopPropagation();
                    this.setModal("edit", true);
                  },
                },
                {
                  show: this.state.selectedFleet !== null,
                  className: "clear",
                  text: <img src={trashcan} alt={I18n.t("evs_deleteFleet")} />,
                  onClick: (e) => {
                    e.stopPropagation();
                    this.setModal("delete", true);
                  },
                },
              ]}
            />
          </div>
          {this.state.fleets.length === 0 && (
            <div className="no-fleets">
              <img src={no_vehicles} alt="" />
              <p className="title">
                <Translate value="evs_noEVsTitle" />
              </p>
              <p className="text">
                <Translate value="evs_noEVsText" />
              </p>
            </div>
          )}
          {this.state.selectedFleet !== null && (
            <>
              <div className="component-container">
                {this.state.selectedFleet.listEvs.length > 0 && (
                  <div className="table-container">
                    <div className="table-header">
                      <div className="row no-gutters">
                        <div className="col-12 row no-gutters titles">
                          <div className="col title">
                            <Translate value="evs_vehicles" />
                          </div>
                          <div className="col title">
                            <Translate value="evs_plate" />
                          </div>
                          {this.props.userPackage?.mileageEntryEnabled && (
                            <div className="col title">
                              <Translate value="kms_title" />
                            </div>
                          )}
                          <div className="col title">
                            <Translate value="evs_range" />
                          </div>
                          <div className="col title">
                            <Translate value="evs_drivers" />
                          </div>
                          <div className="col title">
                            <Translate value="evs_batteryCapacity" />
                          </div>
                          <div className="col title">
                            <Translate value="evs_internalChargePower" />
                          </div>
                          <div className="col title">
                            <Translate value="evs_fastChargePower" />
                          </div>

                          {this.props.userPackage?.mileageEntryEnabled && (
                            <div className="col title">
                              <Translate value="evs_columnKmPermission" />
                            </div>
                          )}
                          {this.props.userPackage?.mileageEntryEnabled && (
                            <div className="col title">
                              <Translate value="evs_columnKmEdit" />
                            </div>
                          )}
                          <div className="col title">
                            <Translate value="myEvs_cardActive" />
                          </div>
                          <div className="col-1 title">
                            {/* blank col for edit and delete buttons */}
                          </div>
                        </div>
                        {/*                           <div
                            className="col-2" 
                          /> */}
                      </div>
                    </div>
                    <div className="table-values">
                      {this.state.selectedFleet?.listEvs
                        .filter((i) => searchModule.filter(this, i))
                        .map((veh) => {
                          return (
                            <div
                              key={veh._id}
                              className="row no-gutters"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.safeSetState({ selectedEV: veh }, () =>
                                  this.setModal("specsEV", true)
                                );
                              }}
                            >
                              <div className="col-12 row no-gutters values slim">
                                <div
                                  className={
                                    "col " +
                                    (veh.primaryEV
                                      ? "main-vehicle"
                                      : "primary-ev-btn")
                                  }
                                >
                                  {veh.brand === "TYPECARD" ||
                                  veh.brand === "TYPEUSER"
                                    ? `${I18n.t(veh.brand)} ${veh.model}`
                                    : `${veh.brand} ${veh.model}`}
                                </div>
                                <div
                                  className="col"
                                  style={{ overflow: "hidden" }}
                                >
                                  <div
                                    className="elipsisOnLicensePlate"
                                    title={veh.licensePlate}
                                  >
                                    {veh.licensePlate}
                                  </div>
                                </div>
                                {this.props.userPackage
                                  ?.mileageEntryEnabled && (
                                  <div className="col">
                                    {veh.listOfKMs === undefined ||
                                    veh.listOfKMs === []
                                      ? "-"
                                      : veh.listOfKMs[
                                          veh.listOfKMs.length - 1
                                        ] === undefined
                                      ? "-"
                                      : Math.round(
                                          veh.listOfKMs[
                                            veh.listOfKMs.length - 1
                                          ].kms
                                        ) + "km"}
                                  </div>
                                )}

                                <div className="col">
                                  {veh.evInfo && veh.evInfo.range
                                    ? `${veh.evInfo.range}km`
                                    : "-"}
                                </div>
                                <div className="col">
                                  {veh && this.getNumberOfDrivers(veh)}
                                </div>
                                <div className="col">
                                  {veh.evInfo &&
                                  veh.evInfo.maxBatteryCapacity !== null
                                    ? `${veh.evInfo.maxBatteryCapacity}kWh`
                                    : "-"}
                                </div>
                                <div className="col">
                                  {veh.evInfo &&
                                  veh.evInfo.internalChargerPower !== null
                                    ? `${veh.evInfo.internalChargerPower}kW`
                                    : "-"}
                                </div>
                                <div className="col">
                                  {veh.evInfo &&
                                  veh.evInfo.maxFastChargingPower !== null
                                    ? `${veh.evInfo.maxFastChargingPower}kW`
                                    : "-"}
                                </div>
                                {this.props.userPackage
                                  ?.mileageEntryEnabled && (
                                  <div
                                    className="col-1"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    style={{
                                      flex: 1,
                                      marginLeft: -10,
                                    }}
                                  >
                                    <div className="check-field">
                                      {veh.acceptKMs ? (
                                        <img
                                          src={yes}
                                          alt=""
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleToggleAcceptKms(
                                              veh.evId,
                                              !veh.acceptKMs
                                            );
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={no}
                                          alt=""
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleToggleAcceptKms(
                                              veh.evId,
                                              !veh.acceptKMs
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                )}

                                {this.props.userPackage
                                  ?.mileageEntryEnabled && (
                                  <div
                                    className="col-1"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    style={{ flex: 1 }}
                                  >
                                    <div className="check-field">
                                      {veh.updateKMs ? (
                                        <img
                                          src={yes}
                                          alt=""
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            veh.acceptKMs
                                              ? this.handleToggleEditKms(
                                                  veh.evId,
                                                  !veh.updateKMs
                                                )
                                              : this.props.setAlert(
                                                  I18n.t("evs_updateKmsError"),
                                                  "danger"
                                                );
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={no}
                                          alt=""
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            veh.acceptKMs
                                              ? this.handleToggleEditKms(
                                                  veh.evId,
                                                  !veh.updateKMs
                                                )
                                              : this.props.setAlert(
                                                  I18n.t("evs_updateKmsError"),
                                                  "danger"
                                                );
                                          }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="col">
                                  {veh.contract?.cardPhysicalStateInfo ===
                                  "ACTIVE"
                                    ? I18n.t("general_yes")
                                    : I18n.t("general_no")}
                                </div>
                                <div className="col-1 center">
                                  <img
                                    style={{ cursor: "pointer" }}
                                    src={
                                      this.props.brand?.icons?.cards?.small ??
                                      evioSmallCard
                                    }
                                    alt={"evio card"}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.safeSetState(
                                        { selectedEV: veh },
                                        () =>
                                          this.setSelectedEVCardNetworkStatus(
                                            veh?.contract,
                                            () => {
                                              this.setModal("contractEV", true);
                                            }
                                          )
                                      );
                                    }}
                                  />
                                  <button
                                    type="button"
                                    style={{ marginLeft: "auto" }}
                                    className="clear"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.safeSetState(
                                        { selectedEV: veh },
                                        () =>
                                          this.setModal(
                                            this.state.selectedEV.evType ===
                                              "car"
                                              ? "editEV"
                                              : this.state.selectedEV.brand ===
                                                "TYPECARD"
                                              ? "editCard"
                                              : this.state.selectedEV.brand ===
                                                "TYPEUSER"
                                              ? "editUser"
                                              : "editOtherEV",
                                            true
                                          )
                                      );
                                    }}
                                  >
                                    <img src={pencil} alt="" />
                                  </button>
                                  <button
                                    type="button"
                                    className="clear"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.safeSetState(
                                        { selectedEV: veh },
                                        () => this.setModal("deleteEV", true)
                                      );
                                    }}
                                  >
                                    <img src={trashcan} alt="" />
                                  </button>
                                </div>
                              </div>
                              {/*                                 <div
                                  className="col-2 blank"
                                >
                                  <button
                                    type="button"
                                    className="assign-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.safeSetState(
                                        { selectedEV: veh },
                                        () => this.setModal("assign", true)
                                      );
                                    }}
                                  >
                                    <Translate value="evs_assignDrivers" />
                                  </button> 
                                </div> */}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
                {this.state.fleets.length > 0 &&
                  this.state.selectedFleet.listEvs.length === 0 && (
                    <div className="no-vehicles">
                      <div className="fleet-img">
                        <img src={car} alt="" className="back-car" />
                        <img src={car} alt="" className="main-car" />
                        <img src={car} alt="" className="back-car" />
                      </div>
                      <p>
                        <Translate value="evs_noVehiclesText" />
                      </p>
                    </div>
                  )}
              </div>
              {this.state.selectedFleet !== null && (
                <div className="button-container">
                  <div>
                    <button
                      type="button"
                      className="add-car-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.safeSetState({ selectedEV: null }, () =>
                          this.setModal("addEV", true)
                        );
                      }}
                      disabled={
                        this.props.isAdmin === false &&
                        this.state.selectedFleet.listEvs.length >=
                          this.props.userPackage?.evsLimit
                      }
                    >
                      <Translate value="evs_addCar" />
                    </button>
                    <button
                      type="button"
                      className="add-other-ev-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.safeSetState({ selectedEV: null }, () =>
                          this.setModal("addOtherEV", true)
                        );
                      }}
                      disabled={
                        this.props.isAdmin === false &&
                        this.state.selectedFleet.listEvs.length >=
                          this.props.userPackage?.evsLimit
                      }
                    >
                      <Translate value="evs_addOtherEV" />
                    </button>
                    <button
                      type="button"
                      className="add-card-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.safeSetState({ selectedEV: null }, () =>
                          this.setModal("addCard", true)
                        );
                      }}
                      disabled={
                        this.props.isAdmin === false &&
                        this.state.selectedFleet.listEvs.length >=
                          this.props.userPackage?.evsLimit
                      }
                    >
                      <Translate value="evs_addCard" />
                    </button>
                    <button
                      type="button"
                      className="add-user-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.safeSetState({ selectedEV: null }, () =>
                          this.setModal("addUser", true)
                        );
                      }}
                      disabled={
                        this.props.isAdmin === false &&
                        this.state.selectedFleet.listEvs.length >=
                          this.props.userPackage?.evsLimit
                      }
                    >
                      <Translate value="evs_addUser" />
                    </button>
                  </div>

                  <div className="exportMarginBottom">
                    <button
                      type="button"
                      className="export-btn-history"
                      onClick={() => this.setModal("choiceEvs", true)}
                    >
                      <div className="export-bt-text">
                        <Translate value="exportAssets_evs" />
                      </div>
                      <img alt="evio_img7" src={download} />
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          <div id="downloadFile" style={{ visibility: "hidden" }} />
          <div id="downloadFile2" style={{ visibility: "hidden" }} />
        </div>

        <ChoiceModal
          //choiceEvs
          show={this.state.modals.choiceEvs}
          onHide={() => this.setModal("choiceEvs", false)}
          choices={[
            { content: "CSV", name: "csv" },
            { content: "XLSX", name: "xlsx" },
          ]}
          chooseBtnLabel="exportAssets_evs"
          onChoose={(e) => this.handleOnChooseEvs(e)}
        />

        <ChoiceModal
          show={this.state.modals.choice}
          onHide={() => this.setModal("choice", false)}
          choices={[
            { content: "CSV", name: "csv" },
            { content: "XLSX", name: "xlsx" },
          ]}
          chooseBtnLabel="kms_export"
          onChoose={(e) => this.handleOnChoose(e)}
        />

        {this.state.modals.edit ? (
          <ActionFleet
            mode="edit"
            show={this.state.modals.edit}
            onHide={() => this.setModal("edit", false)}
            onSubmit={this.handleEditFleet}
            selectedFleet={this.state.selectedFleet}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        ) : (
          <ActionFleet
            mode="add"
            show={this.state.modals.add}
            onHide={() => this.setModal("add", false)}
            onSubmit={this.handleAddFleet}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        )}

        <ConfirmationModal
          show={this.state.modals.delete}
          onHide={() => this.setModal("delete", false)}
          title="evs_deleteFleet"
          body="evs_deleteFleetText"
          button="evs_deleteFleet"
          onConfirm={this.handleDeleteFleet}
          loading={this.state.loadingActionCards}
        />

        {this.state.modals.addEV ? (
          <ActionEV
            show={this.state.modals.addEV}
            onHide={() => this.setModal("addEV", false)}
            mode="add"
            onSubmit={this.handleAddEV}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        ) : (
          <ActionEV
            show={this.state.modals.editEV}
            onHide={() =>
              this.safeSetState({ selectedEV: null }, () =>
                this.setModal("editEV", false)
              )
            }
            mode="edit"
            onSubmit={this.handleEditEV}
            selectedEV={this.state.selectedEV}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        )}

        {this.state.modals.addOtherEV ? (
          <ActionOtherEV
            show={this.state.modals.addOtherEV}
            onHide={() => this.setModal("addOtherEV", false)}
            mode="add"
            onSubmit={this.handleAddOtherEV}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        ) : (
          <ActionOtherEV
            show={this.state.modals.editOtherEV}
            onHide={() =>
              this.safeSetState({ selectedEV: null }, () =>
                this.setModal("editOtherEV", false)
              )
            }
            mode="edit"
            onSubmit={this.handleEditOtherEV}
            selectedEV={this.state.selectedEV}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        )}

        {this.state.modals.addCard ? (
          <ActionCard
            show={this.state.modals.addCard}
            onHide={() => this.setModal("addCard", false)}
            mode="add"
            onSubmit={this.handleAddCardUser}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        ) : (
          <ActionCard
            show={this.state.modals.editCard}
            onHide={() =>
              this.safeSetState({ selectedEV: null }, () =>
                this.setModal("editCard", false)
              )
            }
            mode="edit"
            onSubmit={this.handleEditCardUser}
            selectedEV={this.state.selectedEV}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        )}
        {!this.state.modals.addUser ? (
          <ActionUser
            show={this.state.modals.editUser}
            onHide={() =>
              this.safeSetState({ selectedEV: null }, () =>
                this.setModal("editUser", false)
              )
            }
            mode="edit"
            onSubmit={this.handleEditCardUser}
            selectedEV={this.state.selectedEV}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        ) : (
          <ActionUser
            show={this.state.modals.addUser}
            onHide={() => this.setModal("addUser", false)}
            mode="add"
            onSubmit={this.handleAddCardUser}
            toggleLoadingActionCards={this.toggleLoadingActionCards}
            loading={this.state.loadingActionCards}
          />
        )}
        {this.state?.selectedEV?.contract?.rfidUIState && (
          <ContractEV
            rfidUIState={this.state?.selectedEV?.contract?.rfidUIState}
            updaterfidUIState={this.updaterfidUIState}
            show={this.state.modals.contractEV}
            onHide={() => this.setModal("contractEV", false)}
            selectedEV={this.state.selectedEV}
            selectedEVCardNetworkStatus={this.state.selectedEVCardNetworkStatus}
            activateNetwork={this.activateNetwork}
            deactivateNetwork={this.deactivateNetwork}
            joinNetwork={this.joinNetwork}
            fetchFleets={this.fetchFleets}
            onJoin={this.onJoin}
            isLoadingNetworkMobie={this.state.isLoadingNetworkMobie}
            isLoadingNetworkGireve={this.state.isLoadingNetworkGireve}
            updateSelectedEV={this.updateSelectedEV}
          />
        )}

        {this.state.modals.specsEV && (
          <SpecsEV
            show={this.state.modals.specsEV}
            onHide={() =>
              this.safeSetState({ selectedEV: null }, () =>
                this.setModal("specsEV", false)
              )
            }
            assignDrivers={() =>
              this.setModal("assign", true, () =>
                this.setModal("specsEV", false)
              )
            }
            selectedEV={this.state.selectedEV}
            fetchFleets={this.fetchFleets}
          />
        )}

        <ConfirmationModal
          show={this.state.modals.deleteEV}
          onHide={() => this.setModal("deleteEV", false)}
          title="evs_deleteEV"
          body="evs_deleteEVText"
          button="evs_deleteEV"
          onConfirm={this.handleDeleteEV}
          loading={this.state.loadingActionCards}
        />

        <AssignDriver
          show={this.state.modals.assign}
          onHide={() =>
            this.safeSetState({ selectedEV: null }, () =>
              this.setModal("assign", false)
            )
          }
          onAssign={this.handleAssignDriver}
          selectedEV={this.state.selectedEV}
          invoiceType={this.state.invoiceType}
          invoiceCommunication={this.state.invoiceCommunication}
          onChangeInvoiceType={(e) => this.handleInvoiceTypeChange(e)}
          onChangeInvoiceCommunication={(e) =>
            this.handleInvoiceCommunicationChange(e)
          }
          numberOfDrivers={this.getNumberOfDrivers(this.state.selectedEV)}
        />
      </>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(MyEVs);